/**
 * Сохранение поиска в историю и уведомление о цепочке прояснения.
 * Зависит от render-helpers.js (_safeEscape, getDictNameFromResults),
 * storage.js (addToHistory, getHistoryById, getHistoryRootChain),
 * render.js (renderHistory — вызывается через window.renderHistory).
 * # ⛓️ CURSOR_ANCHOR:search:history-render-save
 */

// Консьюм PENDING_PARENT_ID с проверкой свежести. Вызывается один раз на сохранение.
// Guard 30s: API может отвечать долго (особенно vector search), нельзя терять parentId
// из-за медленного ответа. 30 секунд достаточно даже для самых тяжёлых запросов,
// а если юзер успел уйти и сделать что-то другое за 30с — значение стейл.
function _consumePendingParent() {
  var pid = window.PENDING_PARENT_ID || null;
  var ts = window.PENDING_PARENT_TS || 0;
  window.PENDING_PARENT_ID = null;
  window.PENDING_PARENT_TS = 0;
  if (!pid) return null;
  if (Date.now() - ts > 30000) return null;
  return pid;
}

/**
 * Показывает баннер «Добавлено в цепочку прояснения» над результатами поиска.
 * Breadcrumb показывает путь: root → ... → parent → current.
 * Ссылка «Отменить» отвязывает запись от цепочки.
 * Auto-dismiss через 8 секунд.
 */
function _showChainNotification(newId) {
  // Удаляем предыдущий баннер если есть
  var old = document.querySelector('.chain-notification');
  if (old) old.remove();

  var chain = [];
  if (window.getHistoryRootChain) {
    chain = window.getHistoryRootChain(newId);
  }
  if (chain.length < 2) return; // Нет цепочки — не показываем

  var container = document.getElementById('results-container');
  if (!container) return;

  // Breadcrumb: root → ... → parent → current
  var crumbs = chain.map(function(it) {
    return window._safeEscape(it.displayTerm || it.term || it.query || '');
  });
  var breadcrumbHtml = crumbs.map(function(c, i) {
    if (i === crumbs.length - 1) return '<strong>' + c + '</strong>';
    return '<span class="chain-crumb">' + c + '</span>';
  }).join(' <span class="chain-arrow"><i class="bi bi-chevron-right" aria-hidden="true"></i></span> ');

  var banner = document.createElement('div');
  banner.className = 'chain-notification new-result';
  banner.setAttribute('data-search-result', 'true');
  banner.style.animationDelay = '0ms';
  // i18n texts
  var _lang = 'en';
  if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) _lang = window.SEARCH_LANGUAGE.getCurrentLang();
  var _t = (window.LANG_TEXTS && window.LANG_TEXTS[_lang]) || {};
  var labelText = _t.chain_added_label || 'Added to clarification chain';
  var undoText = _t.chain_undo_btn || "Don't add\nto chain";

  banner.innerHTML =
    '<div class="chain-notification-body">' +
      '<span class="chain-notification-label">' + window._safeEscape(labelText) + '</span>' +
      '<div class="chain-notification-breadcrumb">' + breadcrumbHtml + '</div>' +
    '</div>' +
    '<button type="button" class="chain-notification-undo" data-detach-id="' + window._safeEscape(newId) + '">' +
      '<i class="bi bi-slash-circle chain-notification-undo-icon" aria-hidden="true"></i>' +
      '<span class="chain-notification-undo-text">' + window._safeEscape(undoText) + '</span>' +
    '</button>' +
    '<button type="button" class="chain-notification-close" aria-label="' + window._safeEscape(_t.btn_close || 'Close') + '"><i class="bi bi-x-lg" aria-hidden="true"></i></button>';

  // Вставляем перед первым результатом
  var firstResult = container.querySelector('.opredelenie, .fuzzy-search-message');
  if (firstResult) {
    container.insertBefore(banner, firstResult);
  } else {
    container.prepend(banner);
  }

  // Smooth collapse dismiss: fade + shrink height over 1s
  function _dismissBanner() {
    if (!banner.parentNode) return;
    var h = banner.offsetHeight;
    banner.style.height = h + 'px';
    banner.style.overflow = 'hidden';
    banner.style.transition = 'opacity 0.4s ease, height 0.8s ease, margin 0.8s ease, padding 0.8s ease';
    // Force reflow before changing values
    banner.offsetHeight;
    banner.style.opacity = '0';
    banner.style.height = '0';
    banner.style.marginBottom = '0';
    banner.style.paddingTop = '0';
    banner.style.paddingBottom = '0';
    setTimeout(function() { if (banner.parentNode) banner.remove(); }, 900);
  }

  // Обработчик «Отменить» — отвязка от цепочки
  var undoLink = banner.querySelector('.chain-notification-undo');
  if (undoLink) {
    undoLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.detachHistoryItem) {
        window.detachHistoryItem(newId);
      }
      // Refresh chain panel — item is now detached (new root)
      if (window.CHAIN_PANEL && window.CHAIN_PANEL.update) {
        window.CHAIN_PANEL.update(window.CURRENT_HISTORY_ID);
      }
      _dismissBanner();
    });
  }

  // Кнопка закрытия
  var closeBtn = banner.querySelector('.chain-notification-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      _dismissBanner();
    });
  }

  // Auto-dismiss через 8 секунд
  setTimeout(function() {
    _dismissBanner();
  }, 8000);
}

/**
 * Показывает баннер «Вы вышли из цепочки» с кнопкой «Добавить в цепочку».
 * Срабатывает, когда пользователь вручную ввёл новый запрос, находясь в цепочке,
 * и новая запись оказалась новой корневой (оторванной от предыдущей цепочки).
 * Кнопка перепривязывает новую запись как ребёнка prevChainId.
 */
function _showLeftChainNotification(newId, prevChainId) {
  var old = document.querySelector('.chain-notification');
  if (old) old.remove();

  var prevChain = window.getHistoryRootChain ? window.getHistoryRootChain(prevChainId) : [];
  if (!prevChain || prevChain.length === 0) return;

  var container = document.getElementById('results-container');
  if (!container) return;

  var crumbs = prevChain.map(function(it) {
    return window._safeEscape(it.displayTerm || it.term || it.query || '');
  });
  var arrowSvg = '<span class="chain-arrow"><i class="bi bi-chevron-right" aria-hidden="true"></i></span>';
  var breadcrumbHtml = crumbs.map(function(c, i) {
    if (i === crumbs.length - 1) return '<strong>' + c + '</strong>';
    return '<span class="chain-crumb">' + c + '</span>';
  }).join(' ' + arrowSvg + ' ');

  var banner = document.createElement('div');
  banner.className = 'chain-notification chain-notification--left new-result';
  banner.setAttribute('data-search-result', 'true');
  banner.style.animationDelay = '0ms';

  var _lang = 'en';
  if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) _lang = window.SEARCH_LANGUAGE.getCurrentLang();
  var _t = (window.LANG_TEXTS && window.LANG_TEXTS[_lang]) || {};
  var labelText = _t.chain_left_label || 'You left the chain';
  var rejoinText = _t.chain_rejoin_btn || 'Add to chain';

  banner.innerHTML =
    '<div class="chain-notification-body">' +
      '<span class="chain-notification-label">' + window._safeEscape(labelText) + '</span>' +
      '<div class="chain-notification-breadcrumb">' + breadcrumbHtml + '</div>' +
    '</div>' +
    '<button type="button" class="chain-notification-rejoin" data-rejoin-id="' + window._safeEscape(newId) + '" data-parent-id="' + window._safeEscape(prevChainId) + '">' +
      '<i class="bi bi-plus-circle chain-notification-rejoin-icon" aria-hidden="true"></i>' +
      '<span class="chain-notification-rejoin-text">' + window._safeEscape(rejoinText) + '</span>' +
    '</button>' +
    '<button type="button" class="chain-notification-close" aria-label="' + window._safeEscape(_t.btn_close || 'Close') + '"><i class="bi bi-x-lg" aria-hidden="true"></i></button>';

  var firstResult = container.querySelector('.opredelenie, .fuzzy-search-message');
  if (firstResult) {
    container.insertBefore(banner, firstResult);
  } else {
    container.prepend(banner);
  }

  function _dismissBanner() {
    if (!banner.parentNode) return;
    var h = banner.offsetHeight;
    banner.style.height = h + 'px';
    banner.style.overflow = 'hidden';
    banner.style.transition = 'opacity 0.4s ease, height 0.8s ease, margin 0.8s ease, padding 0.8s ease';
    banner.offsetHeight;
    banner.style.opacity = '0';
    banner.style.height = '0';
    banner.style.marginBottom = '0';
    banner.style.paddingTop = '0';
    banner.style.paddingBottom = '0';
    setTimeout(function() { if (banner.parentNode) banner.remove(); }, 900);
  }

  var rejoinBtn = banner.querySelector('.chain-notification-rejoin');
  if (rejoinBtn) {
    rejoinBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.reparentHistoryItem && window.reparentHistoryItem(newId, prevChainId)) {
        if (window.CHAIN_PANEL) {
          if (window.CHAIN_PANEL.update) window.CHAIN_PANEL.update(newId);
          // Явно раскрываем панель: пользователь только что попросил вернуть
          // термин в цепочку — он ожидает увидеть её обновлённой.
          if (window.CHAIN_PANEL.open) window.CHAIN_PANEL.open();
        }
        var dropdownEl = document.getElementById('search-history-dropdown');
        if (dropdownEl && dropdownEl.classList.contains('active') && window.renderHistory) {
          window.renderHistory(false);
        }
      }
      _dismissBanner();
    });
  }

  var closeBtn = banner.querySelector('.chain-notification-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', _dismissBanner);
  }

  // Auto-dismiss через 30 секунд — требуется решение пользователя, даём достаточно времени.
  setTimeout(_dismissBanner, 30000);
}

/**
 * Проверяет условия и показывает баннер «вышли из цепочки».
 * Условия: новая запись — корень (без parent), prevChainId был в цепочке
 * (есть parent или есть children), cross-link не использовался.
 */
function _maybeShowLeftChainNotification(newId, prevChainId) {
  if (!newId || !prevChainId || newId === prevChainId) return;
  if (!window.getHistoryById || !window.getHistoryRootChain || !window.getHistoryChildren) return;

  var newRec = window.getHistoryById(newId);
  if (!newRec || newRec.parentId) return; // Уже в цепочке — не показываем.

  var prevRec = window.getHistoryById(prevChainId);
  if (!prevRec) return;

  var prevChain = window.getHistoryRootChain(prevChainId);
  var prevChildren = window.getHistoryChildren(prevChainId);
  // Контекст цепочки: есть родитель или дети.
  if (prevChain.length < 2 && prevChildren.length === 0) return;

  // Защита от цикла: newId не должен быть предком prevChainId.
  var isAncestor = prevChain.some(function(it) { return it.id === newId; });
  if (isAncestor) return;

  _showLeftChainNotification(newId, prevChainId);
}

/**
 * Определяет текущий язык поиска из доступных источников.
 */
function _resolveSearchLang(lang) {
  if (lang && lang !== 'en' && lang !== '') return lang;

  if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) {
    lang = window.SEARCH_LANGUAGE.getCurrentLang();
  }
  if (!lang || lang === 'en') {
    var pathLang = window.location.pathname.split('/')[1];
    if (['en', 'ru', 'de', 'fr'].indexOf(pathLang) !== -1) {
      lang = pathLang;
    }
  }
  return lang || 'en';
}

/**
 * Определяет текущий режим поиска (smart/classical).
 */
function _resolveSearchType(searchType) {
  if (searchType !== null && searchType !== undefined && searchType !== '') return searchType;

  var searchTypeHidden = document.getElementById('search-type-hidden');
  if (searchTypeHidden && searchTypeHidden.value) {
    searchType = searchTypeHidden.value;
  } else {
    var searchTypeRadios = document.querySelectorAll('input[name="search-type"]:checked');
    if (searchTypeRadios.length > 0) {
      searchType = searchTypeRadios[0].value;
    } else {
      searchType = '';
    }
  }

  // Миграция старых типов
  if (!searchType || searchType === 'exact' || searchType === 'broad' ||
      searchType === 'description' || searchType === 'broad-without-vector' ||
      searchType === '') {
    searchType = 'classical';
  } else if (searchType === 'broad-with-vector') {
    searchType = 'smart';
  }
  return searchType;
}

/**
 * Выполняет фактическое сохранение в историю и обновляет UI dropdown.
 */
function _doSaveAndUpdateUI(searchTerm, lang, searchType, pendingParentId, prevChainId) {
  var dictName = getDictNameFromResults();
  var newId;
  if (typeof addToHistory === 'function') {
    newId = addToHistory(searchTerm, lang, dictName, searchType, pendingParentId);
  } else if (window.addToHistory) {
    newId = window.addToHistory(searchTerm, lang, dictName, searchType, pendingParentId);
  }
  if (pendingParentId && newId) {
    _showChainNotification(newId);
  } else if (newId && prevChainId && newId !== prevChainId) {
    _maybeShowLeftChainNotification(newId, prevChainId);
  }

  // Update chain panel (desktop side navigation)
  if (window.CHAIN_PANEL && window.CHAIN_PANEL.update) {
    window.CHAIN_PANEL.update(newId || window.CURRENT_HISTORY_ID);
  }

  // Обновляем dropdown если открыт, чтобы is-active отразил новый CURRENT_HISTORY_ID
  var dropdownEl = document.getElementById('search-history-dropdown');
  if (dropdownEl && dropdownEl.classList.contains('active') && window.renderHistory) {
    window.renderHistory(false);
    var activeEl = dropdownEl.querySelector('.search-history-item.is-active');
    if (activeEl) {
      dropdownEl.querySelectorAll('.search-history-item.selected').forEach(function(el) { el.classList.remove('selected'); });
      activeEl.classList.add('selected');
      activeEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }
  return newId;
}

// Сохранить поиск в историю после успешной загрузки результатов
function saveSearchToHistory(searchTerm, lang, searchType) {
  var historyDisabled = false;
  if (typeof isHistoryDisabled === 'function') {
    historyDisabled = isHistoryDisabled();
  } else if (window.isHistoryDisabled) {
    historyDisabled = window.isHistoryDisabled();
  }

  if (historyDisabled || !searchTerm || !searchTerm.trim()) {
    _consumePendingParent();
    return;
  }

  // Фиксируем предыдущий CURRENT_HISTORY_ID ДО мутаций — нужен для баннера «вышли из цепочки».
  var prevChainId = window.CURRENT_HISTORY_ID || null;

  // Если CURRENT_HISTORY_ID уже восстановлен из URL (?hid=) и query совпадает —
  // запись уже существует в истории, не нужно создавать дубликат.
  // Это случай F5 / открытия ссылки с ?hid=.
  if (window.CURRENT_HISTORY_ID && window.getHistoryById) {
    var existing = window.getHistoryById(window.CURRENT_HISTORY_ID);
    if (existing && existing.query === searchTerm.trim()) {
      _consumePendingParent();

      // Sync searchType if changed (e.g. user toggled AI mode).
      // Bump timestamp ONLY on the branch root (so branch rises to top
      // in dropdown) — never on children (would break chronological order).
      var currentSearchType = _resolveSearchType(searchType);
      var needsSave = false;
      var history = (typeof getHistory === 'function') ? getHistory() : (window.getHistory ? window.getHistory() : []);

      // Find root of this item's branch
      var rootId = null;
      var byIdMap = {};
      history.forEach(function(it) { byIdMap[it.id] = it; });
      var walk = existing;
      var guard = 0;
      while (walk && guard < 100) {
        if (!walk.parentId || !byIdMap[walk.parentId]) { rootId = walk.id; break; }
        walk = byIdMap[walk.parentId];
        guard++;
      }

      // Check if item is a leaf (no children)
      var isLeaf = true;
      for (var ci = 0; ci < history.length; ci++) {
        if (history[ci].parentId === existing.id) { isLeaf = false; break; }
      }

      // For non-leaf: buffer searchType change as pending save
      if (!isLeaf && currentSearchType && existing.searchType !== currentSearchType) {
        var pending = window._CHAIN_PENDING_SAVE || { id: existing.id };
        pending.id = existing.id;
        pending.searchType = currentSearchType;
        pending.displayTerm = pending.displayTerm || existing.displayTerm;
        pending.termIndex = (pending.termIndex !== undefined) ? pending.termIndex : existing.termIndex;
        pending.termGuid = pending.termGuid || existing.termGuid;
        window._CHAIN_PENDING_SAVE = pending;
        if (window.CHAIN_PANEL && window.CHAIN_PANEL.showPendingSave) {
          window.CHAIN_PANEL.showPendingSave(existing.id);
        }
      }

      for (var ei = 0; ei < history.length; ei++) {
        // Update searchType only on leaf items
        if (history[ei].id === existing.id && isLeaf) {
          if (currentSearchType && history[ei].searchType !== currentSearchType) {
            history[ei].searchType = currentSearchType;
            needsSave = true;
          }
        }
        // Bump timestamp only on root (so branch rises to top, children order preserved)
        if (rootId && history[ei].id === rootId) {
          history[ei].timestamp = Date.now();
          needsSave = true;
        }
      }
      if (needsSave && typeof saveHistory === 'function') saveHistory(history);

      // Restore PENDING_TERM for auto-expand of previously opened article
      if (existing.termGuid) {
        window.PENDING_TERM_GUID = existing.termGuid;
        window.PENDING_TERM_INDEX = null;
      } else if (existing.termIndex) {
        window.PENDING_TERM_GUID = null;
        window.PENDING_TERM_INDEX = existing.termIndex;
      }

      console.log('[HISTORY] saveSearchToHistory: EARLY RETURN (dedup) for "' + searchTerm.trim() + '", CURRENT=' + window.CURRENT_HISTORY_ID);
      if (window.syncHistoryIdToUrl) {
        window.syncHistoryIdToUrl(window.CURRENT_HISTORY_ID);
      }
      return;
    }
  }

  // Консьюмим parent ОДИН раз. Значение передаётся и в retry-путь, и в основной.
  var pendingParentId = _consumePendingParent();
  console.log('[HISTORY] saveSearchToHistory: term=' + searchTerm.trim() + ', pendingParentId=' + pendingParentId + ', CURRENT=' + window.CURRENT_HISTORY_ID);

  lang = _resolveSearchLang(lang);

  // Проверяем, есть ли результаты поиска
  var container = document.getElementById('results-container');
  if (!container) return;

  // Сохраняем ТОЛЬКО если есть элементы .opredelenie (реальные определения)
  var results = container.querySelectorAll('.opredelenie');
  var hasResults = results.length > 0;

  // Если результатов нет сразу, пробуем еще раз через небольшую задержку
  if (!hasResults) {
    setTimeout(function() {
      var retryResults = container.querySelectorAll('.opredelenie');
      if (retryResults.length > 0) {
        var retryLang = _resolveSearchLang(lang);
        var retrySearchType = _resolveSearchType(searchType);
        _doSaveAndUpdateUI(searchTerm, retryLang, retrySearchType, pendingParentId, prevChainId);
      }
    }, 200);
    return;
  }

  searchType = _resolveSearchType(searchType);

  console.log('[HISTORY] saveSearchToHistory: ADDED "' + searchTerm.trim() + '", parentId=' + pendingParentId + ', CURRENT now=' + window.CURRENT_HISTORY_ID);
  _doSaveAndUpdateUI(searchTerm, lang, searchType, pendingParentId, prevChainId);
}

window.saveSearchToHistory = saveSearchToHistory;
